// extracted by mini-css-extract-plugin
export default {"root":"Banner_root__JzM6R"};